"use client";
import { Col } from "@/app/components/lib/my-bootstrap";
import calculatPricesForSpecialPrices from "@/utils/functions/calculatPriceForSpecialPrices";
import { useBundleProduct } from "../context/BundleProductContext";
import Price from "@/app/components/lib/Price";
import ProductPriceInfoButton from "../../product/product-box/product-box-helpers/product-price-info/ProductPriceInfoButton";
import BundleAddToCart from "./bundle-add-to-cart";

import { useTranslation } from "@/hooks/localization/useTranslations";
import { Link } from "@/app/components/lib/navigation/Link";

interface Props {}
const BundleActions: React.FC<Props> = () => {
  const { quantity, product, enableAddToCart, showAddToCardBtn } =
    useBundleProduct();
  const t = useTranslation();
  const {
    selling_prices: special_prices,
    price_without_discount,
    price: originalPrice,
    discount_amount,
    discount_type,
    discount,
  } = product;

  const { price, price_without_discount: priceWithoutDiscount } =
    calculatPricesForSpecialPrices({
      originalPrice,
      originalPriceWithoutDiscount: price_without_discount,
      originalDiscountAmount: discount_amount,
      originalDiscountType: discount_type,
      originalDiscount: discount,
    })({ quantity, specialPrices: special_prices });

  return (
    <div style={{ width: "100%" }}>
      {enableAddToCart && (
        <>
          <Col className="p-0">
            <Price
              gap={10}
              priceFirst
              price={{ value: price, className: "bundle-component-price" }}
              priceWithoutDiscount={{
                value: priceWithoutDiscount,
                className: "bundle-component-price-without-discount",
              }}
              roundPrice
              discountAmount={
                special_prices.length === 0
                  ? product.discount_amount
                  : undefined
              }
              badgeFirst
            />
          </Col>
          {(special_prices || [])?.length > 1 && (
            <Col
              className="p-0 align-self-end "
              style={{ marginInline: "5px" }}
            >
              <ProductPriceInfoButton priceInfoData={special_prices} />
            </Col>
          )}
        </>
      )}
      {showAddToCardBtn && (
        <Col className={`p-0 d-flex justify-content-end w-100`}>
          <BundleAddToCart />
        </Col>
      )}
      <Link
        skipCheckingForLang
        prefetch={false}
        href={`/products/${product.slug}`}
        className="product-bundle-title mt-2"
      >
        <p className="m-2 text-decoration-underline">{t.view_details}</p>
      </Link>
    </div>
  );
};

export default BundleActions;
